import { useState, useEffect } from "react";
import axios from 'axios';
import { useTranslation } from "react-i18next";
import { useDispatch } from 'react-redux';
import { setLoading } from '../redux/slices/login';
import { getApiBaseUrl } from '../Utils/api';
function useAxios(url) {
  const [t, i18n] = useTranslation();
  const [Data, setData] = useState([]);
  const token = localStorage.getItem('arab_user_token');
  const dispatch = useDispatch();

  const baseURL = getApiBaseUrl(t("en"));

  useEffect(() => {
    dispatch(setLoading(true));
    axios
      .get(`${baseURL}/${url}`, {
        headers: { "Authorization": `Bearer ${token}` }
      })
      .then((response) => {
        setData(response.data);
        dispatch(setLoading(false));
      })
      .catch((error) => {
        console.error(error);
        dispatch(setLoading(false));
      });
  }, [url, i18n.language]);

  return [Data, setData];
}


export default useAxios;
